import merge from "lodash/merge";

export const mergeStyles = (props) => {

    const styles = [];

    Object.keys(props).forEach(key => {

        const value = props[key];

        if (Array.isArray(value))
            styles.push(...value);
        else if (value)
            styles.push(value);
        
    });

    return merge({}, ...styles);

}